export function riskScoreToText(score) {
    if(score <= 0.0) {
        return 'N/A';
    } else if(score <= 0.25) {
        return 'Low';
    } else if(score <= 0.5) {
        return 'Normal';
    } else if(score <= 0.75) {
        return 'Moderate';
    } else {
        return 'High';
    }
}
